export interface StockItemMagento {
  id: string;
  productKey: string;
  productDescription: string;
  stockQty: number;
}
